import type { FaireProductEntity } from "../../entity_types/product";

export const p_y8zsns8kb3: FaireProductEntity = {
  token: "p_y8zsns8kb3",
  type: "product",
  name: "Sexy Bitch Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/9e30d398d0caff847a6ec4e3ea600f4d9d093d2cae64a7bacf8a455e3c07a587.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ecbdda52082f9b51b34fcd74ad8b9b17a0e11d49d5f597b78859a370881fd1dd.jpeg",
    "https://cdn.faire.com/fastly/6e8f6dde23508a4b92e80249566b8d83e9f11c0359cd7bcbbac8868c8da5036c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/7824ae1d3b22e391ce757f54eec706c4b0ad2f491c70895a2e4a89ab30756521.jpeg",
    "https://cdn.faire.com/fastly/30b8c80f09991d25a9db6f9ae117261806b10e0993547c2ceea8469c968468b6.jpeg",
    "https://cdn.faire.com/fastly/b7c99f41a55398bf1ab323a76dcd56b03c8cf713c37b91a80f46620fff50e9d4.jpeg",
    "https://cdn.faire.com/fastly/7a7cc904493b4d27f11f1b086572d3c0f8ef86e8959b36b8f83ea6ed315ef58d.jpeg"
  ],
  priceDollars: 6.75,
  description: "You should be traipsing around in these if you're the type that doesn’t wait for a compliment — you are the compliment. 💅\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:12.580Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
